import React,  { useState, useEffect } from 'react';
import axios from 'axios';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Alert } from '@mui/material/';
import Cookies from 'js-cookie'

import Lst_clubs_officers from './components/officers/lst_club'
import Autorize from '../ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function OfficiersRepport({MyAnnee}) {

    const [autorize, setAutorize] = useState("false");
    const [clublist, setList] = useState([]);
    const [errorAxios, setErrorAxios] = useState("false");

    const [listSecteur, setListSecteur] = useState("");
   
    
  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

    useEffect(() => {
    
        if(autorize)
        {
            MyAxios.get(process.env.REACT_APP_API + '/clubs/getallsecteur') //axios.defaults.withCredentials = true
            .then((res) => {      
                setErrorAxios(false);
                console.log(res);
                setListSecteur(res.data);
               
            })
            .catch((error) => {
                console.log(error)  
              ///  if(error.status)  
               if(error.response.status === 401)// pas autorisé
                 setErrorAxios(true);

            });
        }
                
    },[MyAnnee,autorize]);


   
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table}
    return (
             <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                     
                {Object.entries(listSecteur).map(([key, value]) => (
                    <Grid container spacing={2}>                          
                        <Grid item xs={8}> 
                             <Alert severity="info">Secteur { value.Default_DistrictNbr } Membres actifs par club / mois</Alert>
                        </Grid>
                        <Grid item xs={12}> 
                        <Lst_clubs_officers key={value.Default_DistrictNbr} secteur={value.Default_DistrictNbr} MyAnnee={MyAnnee} />
                       
                        </Grid>
                    </Grid>                     
                ))}

                
                </div>
     );

};

export default OfficiersRepport;